module.exports = __webpack_public_path__ + "front/img/yqhbtn01.3c259742.png";